module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine platform in Greece.f0e582ec.webp";